import { Injectable } from '@angular/core';
import { PickListDataDto } from '@scip/api';
import { MasterDataControllerService } from '@scip/api';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MasterDataService {
  // Lets load the primary article identifier types from the backend, but only once per ui-session
  private readonly primaryArticleIdentifierTypes: Observable<PickListDataDto[]> = this.masterDataControllerService
    .getPrimaryArticleIdentifierTypes()
    .pipe(shareReplay(1));

  private readonly otherArticleNameTypes: Observable<PickListDataDto[]> = this.masterDataControllerService
    .getOtherArticleNamesPickListData()
    .pipe(shareReplay(1));

  constructor(private masterDataControllerService: MasterDataControllerService) {}

  getPrimaryArticleIdentifierTypes(): Observable<PickListDataDto[]> {
    return this.primaryArticleIdentifierTypes;
  }

  getOtherArticleNameTypes(): Observable<PickListDataDto[]> {
    return this.otherArticleNameTypes;
  }
}
